// Source: https://thoughtspile.github.io/2021/04/07/better-usecallback/

import { useCallback, useRef } from 'react'

import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Callback = (...args: any[]) => any

export const useStableCallback = (callback: Callback): Callback => {
  const onChangeInner = useRef(callback)
  useIsomorphicLayoutEffect(() => {
    onChangeInner.current = callback
  })
  return useCallback<Callback>((...args) => onChangeInner.current(...args), [])
}
